import React from 'react';
import { Whisper, Tooltip } from 'rsuite';
import InfoRoundIcon from '@rsuite/icons/InfoRound';

interface InfoIconProps {
  text: string;
}

const InfoIcon = ({ text }: InfoIconProps) => {
  return (
    <Whisper
      trigger={['hover', 'click']}
      speaker={<Tooltip>{text}</Tooltip>}
    >
      <InfoRoundIcon
        aria-label={text}
        data-testid="info-icon"
        role="button"
        style={{ cursor: 'pointer' }}
        tabIndex={0}
      />
    </Whisper>
  );
};

export default InfoIcon;
